import shared from "./shared";
import login from "./login";
import changePassword from "./changePassword";
import forgetPassword from "./forgetPassword";
import resetPassword from "./resetPassword";
import admins from "./admins";
import inputsValidations from "./inputsValidations";
import pagesTitles from "./pagesTitles";
import successMsgs from "./successMsgs";
import products from "./products";
import notifications from "./notifications";
import categories from "./categories";
import subCategories from "./subCategories";
import users from "./users";
import businessVerification from "./businessVerfication";
import vouchers from "./vouchers";
import transactions from "./transactions";
import employees from "./employees";
import roles from "./roles";

const en = {
  shared,
  login,
  changePassword,
  forgetPassword,
  resetPassword,
  admins,
  inputsValidations,
  pagesTitles,
  successMsgs,
  products,
  notifications,
  categories,
  subCategories,
  users,
  businessVerification,
  vouchers,
  employees,
  roles,
  transactions
};

export default en;
